import React, { useContext } from 'react'
import styled from 'styled-components'

import {
   BoxContainerLighter,
   H2,
   SectionHeader,
   TwoColumnContent
} from '@welcom/esg-react-components'
import { Statusbar } from '../components/Statusbar'
import { AppContext } from '../appState'

const AlignLeft = styled.div`
   text-align: left;
`

export const Review = () => {
   const { store } = useContext(AppContext)
   console.log(store)
   return (
      <AlignLeft>
         <BoxContainerLighter>
            <Statusbar currentStep={4} />
            <H2>Review and submit</H2>

            <SectionHeader title={'Pupil'} />
            <TwoColumnContent>
               <div>
                  <p>
                     <b>Pupil</b>
                     <br />
                     {store.pupil.name ?? '- '}, {store.pupil.SSN ?? ' -'}
                  </p>

                  <p>
                     <b>Previous school or daycare</b>
                     <br />
                     {store.pupil.prevSchool ?? '-'}
                  </p>
               </div>
               <div>
                  <p>
                     <b>Language spoken at home</b>
                     <br />
                     {store.pupil.language ?? '-'}
                  </p>

                  <p>
                     <b>When would you like your child to start?</b>
                     <br />
                     {store.pupil.startDate ?? '-'}
                  </p>
               </div>
            </TwoColumnContent>

            <SectionHeader title={'Guardians'} />
            <TwoColumnContent>
               <div>
                  <p>
                     <b>Guardian 1</b>
                     <br />
                     {store.guardians[0].name ?? '-'}{' '}
                     {store.guardians[0].surname ?? '-'}
                  </p>

                  <p>
                     <b>Email</b>
                     <br />
                     {store.guardians[0].email ?? '-'}
                  </p>

                  <p>
                     <b>Address</b>
                     <br />
                     {store.guardians[0].address ?? ''},{' '}
                     {store.guardians[0].postalCode ?? ''}{' '}
                     {store.guardians[0].city ?? ''}
                  </p>
               </div>
               <div>
                  <p>
                     <b>Phone mobile</b>
                     <br />
                     {store.guardians[0].phoneMobile ?? '-'}
                  </p>

                  <p>
                     <b>Phone home</b>
                     <br />
                     {store.guardians[0].phoneHome ?? '-'}
                  </p>
               </div>
               {Object.keys(store.guardians[1]).length !== 0 && (
                  <>
                     <div>
                        <p>
                           <b>Guardian 2</b>
                           <br />
                           {store.guardians[1].name ?? ''}{' '}
                           {store.guardians[1].surname ?? ''}
                        </p>

                        <p>
                           <b>Email</b>
                           <br />
                           {store.guardians[1].email ?? '-'}
                        </p>

                        <p>
                           <b>Address</b>
                           <br />
                           {store.guardians[1].address ?? ''},{' '}
                           {store.guardians[1].postalCode ?? ''}{' '}
                           {store.guardians[1].city ?? ''}
                        </p>
                     </div>
                     <div>
                        <p>
                           <b>Phone mobile</b>
                           <br />
                           {store.guardians[0].phoneMobile ?? '-'}
                        </p>

                        <p>
                           <b>Phone home</b>
                           <br />
                           {store.guardians[0].phoneHome ?? '-'}
                        </p>
                     </div>
                  </>
               )}
            </TwoColumnContent>

            <SectionHeader title={'Siblings'} />
            <TwoColumnContent>
               {store.siblings.length > 0 ? (
                  store.siblings.map((sibling, key) => (
                     <p key={key}>
                        <b>Sibling {key + 1}</b>
                        <br />
                        {sibling.name}, {sibling.SSN}
                     </p>
                  ))
               ) : (
                  <p>
                     <b>No siblings</b>
                  </p>
               )}
            </TwoColumnContent>

            <SectionHeader title={'Fritids'} />
            <TwoColumnContent>
               {store.fritids.fritids ? (
                  <>
                     <p>
                        <b>Drop off </b>
                        <br />
                        {store.fritids.dropOff}
                     </p>
                     <p>
                        <b>Pick up </b>
                        <br />
                        {store.fritids.pickUp}
                     </p>
                  </>
               ) : (
                  <p>
                     <b>No, we don’t want any fritids.</b>
                  </p>
               )}
            </TwoColumnContent>
         </BoxContainerLighter>
      </AlignLeft>
   )
}
